// extracted by mini-css-extract-plugin
export default {"text":"CountPageBox_text__IJtUI"};